module.exports = "<div class=\"app\">\r\n  <navbar \r\n    ng-hide=\"vm.hideNav()\" \r\n    global-filter-options=\"vm.getGlobalFilterOptions()\" \r\n    hide-global-filters=\"vm.hideGlobalFilters()\">\r\n  </navbar>\r\n  <leftnav ng-hide=\"vm.hideNav()\"></leftnav>\r\n  <div ui-view></div>\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/app.html
 ** module id = 977
 ** module chunks = 0
 **/